export default __webpack_public_path__ + "static/media/algo.45f2fb96.png";